//@flow
import React from 'react'
import './styles.scss'

import { Person } from '../Person'

let desktopData = []
let outputData = []

export class Grid extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      data: []
    }
    this.updateSizes = this.updateSizes.bind(this)
    this.sortDesktopData = this.sortDesktopData.bind(this)
  }

  sortDesktopData(originalData) {
    let sortedData = []
    let evenArr = []
    let oddArr = []
      // Put elements in oddArr[] and evenArr[] as per their position
      for (let i = 0; i < originalData.length; i++) {
        if (i % 2 !== 1) {
            evenArr.push(originalData[i]);
        }
        else {
            oddArr.push(originalData[i]);
        }
      }
      let i = 0;
      for (let j = 0; j < evenArr.length; j++) {
        sortedData[i++] = evenArr[j];
      }
      for (let j = 0; j < oddArr.length; j++) {
        sortedData[i++] = oddArr[j];
      }
      return sortedData
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    }, function() {
      outputData = this.state.isMobile ? this.state.data : desktopData
    })
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)

    /* GET SHEET DATA VIA CLOUD STORAGE */
    fetch(
      'https://storage.googleapis.com/ta-interaktiv/30-unter-30/personen.json'
    )
      .then(response => {
        if (response.ok) {
          return response.json()
        } else {
          throw new Error('Cloud Function Data was not OK')
        }
      })
      .then(responseData => {
        this.setState({ data: responseData.data }, function() {
          desktopData = this.sortDesktopData(this.state.data)
          outputData = this.state.isMobile ? this.state.data : desktopData
          this.updateSizes()
        })
      })
    this.updateSizes()
  }

  render() {
    return <div className='grid'>
      <div className='wrapper'>
            {outputData && outputData.map((person, i) => {
              let elementAlign = this.state.isMobile ? i % 2 ? 'right' : 'left' : i < outputData.length/2 ? i % 2 ? 'right' : 'left' : i % 2 ? 'left' : 'right'
              return (
                <div className={'container '+elementAlign} key={'person-'+i}>
                  <Person
                    claim={person.Titel}
                    name={person.Name}
                    passion={person.Taetigkeit}
                    text={
                      person.Text
                    }
                    align={elementAlign}
                    />
                  </div>
                )})
            }
        </div>
        <div className='note'>
          Für die Bebilderung mussten die 30 Bernerinnen und Berner ein Selfie zur Verfügung stellen. Bei der Komposition der Fotos hatten sie freie Hand.
        </div>
      </div>
  }
}



             